import usePopupState from '../../../hooks/usePopupState'
import AnnouncementPopup from './AnnouncementPopup'
import FindPlacePopup from './FindPlacePopup'
import NewPlacePopup from './NewPlacePopup'
import MMScorePopup from './MMScorePopup'
import LegendPopup from './LegendPopup'
import FilterPopup from './FilterPopup'

const Popups = () => {
  const { popup } = usePopupState()

  if (popup) return (
    popup === 'legend' ? <LegendPopup />
      : popup === 'filters' ? <FilterPopup />
        : popup === 'newplace' ? <NewPlacePopup />
          : popup === 'findplace' ? <FindPlacePopup />
            : popup?.type === 'mm_score' ? <MMScorePopup scoreInfo={popup?.scoreInfo} />
              : popup?.type === 'announcement' ? <AnnouncementPopup placeId={popup.placeId} />
                : null
  )

  return null
}

export default Popups